import React, { Fragment, useState } from "react";
import { Formik, Form } from "formik";
import { Button, useTheme, Typography, Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Loader from "../public/Loader";
import { getStyleForThankyouResponse } from "../styles/commonStyles";

const MAX_CHARACTER_LENGTH = 500;

const ScreeningQuestionThree = ({
  questionText,
  textFieldLabel,
  backRoute,
  submitRoute,
  onSubmitHandler,
}) => {
  const theme = useTheme();
  const classes = getStyleForThankyouResponse(theme);
  const [loading, setLoading] = useState(false);
  const [inputText, setInputText] = useState("");
  const location = useLocation();
  const history = useHistory();
  const [helperText, setHelperText] = useState("");
  const [showError, setShowError] = useState(false);

  const handleNextClick = async () => {
    const selectedOption = location.state["selectedOption"];
    const date = location.state["date"];
    const data = {
      [`${selectedOption}`]: {
        note: inputText.trim() === "" ? null : inputText.trim(),
        date,
      },
    };
    setLoading(true);
    await onSubmitHandler(data);
    setLoading(false);
    history.push(submitRoute);
  };

  const handleInput = (event) => {
    const input = event.target.value;
    setInputText(input);
    const length = input.length;
    if (length > MAX_CHARACTER_LENGTH) {
      setHelperText(`Max character limit is ${MAX_CHARACTER_LENGTH}`);
      setShowError(true);
    } else {
      setHelperText("");
      setShowError(false);
    }
  };

  const handleBackClick = () => {
    const selectedOption = location.state["selectedOption"];
    const details = {
      selectedOption,
    };
    history.push({ pathname: backRoute, state: details });
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <Formik initialValues={{ questions: [] }} onSubmit={handleNextClick}>
        {() => (
          <Form>
            <Stack sx={classes.wrapper} gap={"24px"} alignItems="start">
              <Button sx={classes.back} onClick={handleBackClick}>
                <ArrowBackIcon /> &nbsp;Back
              </Button>
              <Stack alignItems="start" gap={1}>
                <Typography sx={classes.subTitle2}>{questionText}</Typography>
                <Typography
                  color="#152438"
                  variant="caption"
                  align="center"
                  fontWeight={400}
                >
                  This question is optional
                </Typography>
              </Stack>
              <TextField
                error={showError}
                id="outlined-basic"
                label={textFieldLabel}
                variant="outlined"
                inputProps={{ maxLength: MAX_CHARACTER_LENGTH + 1 }}
                onInput={handleInput}
                helperText={helperText}
                rows={5}
                fullWidth
                multiline
              />
              <Button type="submit" sx={classes.btnStyle} disabled={showError}>
                Submit
              </Button>
            </Stack>
          </Form>
        )}
      </Formik>
    </Fragment>
  );
};

ScreeningQuestionThree.propTypes = {
  questionText: PropTypes.string.isRequired,
  backRoute: PropTypes.string.isRequired,
  submitRoute: PropTypes.string.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  textFieldLabel: PropTypes.string.isRequired,
};

export default ScreeningQuestionThree;
